// react component called Services for Terms and Services page

const Services = () => {
  return (
    <div style={{ backgroundColor: "white" }}>
      <h1>Privacy Policy </h1>
      <p>
        *1. Data Collection: ACBC collects personal information provided
        voluntarily by users, such as name, email address, and professional
        affiliation, for the purpose of communication and program registration.
        Personal information collected by ACBC is kept confidential and used
        solely for organizational purposes.
      </p>
      <p>
        *2. Data Security: ACBC implements appropriate security measures to
        safeguard user data and prevent unauthorized access or disclosure. Users
        can request to review, update, or delete their personal information by
        contacting ACBC directly.
      </p>
      <p>
        *3. Data Sharing: ACBC does not sell or share user data with third
        parties for commercial purposes. Personal information may be shared with
        partners or service providers for program-related activities.
      </p>
      <p>
        *4. Cookies and Analytics: The ACBC website may use cookies and
        analytics tools to improve user experience and track website usage.
        Users can manage cookie preferences through their browser settings.
      </p>
      <p>
        *5. Contact Information: For inquiries, feedback, or requests regarding
        our educational programs and services, please contact ACBC using the
        provided contact information on the website.
      </p>
    </div>
  );
};
export default Services;
